module.exports = __webpack_public_path__ + "img/nav01.7b7324ed.png";